import { ResolutionStatus, StaffCersRejectionFindingsQuery } from "generated-graphql/graphql";

export type StaffCersRejectionFindingRow =
  StaffCersRejectionFindingsQuery["staffCersRejectionFindings"]["items"][number];

/** Soft StatusChip color per lifecycle status. IGNORED stays a distinct neutral
 *  grey (matching the gen-status exceedance chip, which renders IGNORED separately
 *  rather than folding it into resolved). */
export function resolutionStatusColor(
  status: ResolutionStatus
): "warning" | "info" | "success" | "default" {
  switch (status) {
    case ResolutionStatus.Unresolved:
      return "warning";
    case ResolutionStatus.Pending:
      return "info";
    case ResolutionStatus.Resolved:
      return "success";
    case ResolutionStatus.Ignored:
      return "default";
  }
}

/** Age in whole days on the CUPA-decision clock (decisionDate ‖ detectedAt). */
export function findingAgeDays(row: {
  decisionDate?: string | null;
  detectedAt?: string | null;
}): number | null {
  const anchor = row.decisionDate ?? row.detectedAt;
  if (!anchor) return null;
  const ms = Date.now() - new Date(anchor).getTime();
  return Math.floor(ms / 86_400_000);
}

/** Bulk actions can only target open findings on matched facilities —
 *  unmatched facilities are handled on the staff matching screen first,
 *  and terminal findings would only produce guaranteed failures. */
export function isFindingSelectable(row: StaffCersRejectionFindingRow): boolean {
  const open =
    row.status === ResolutionStatus.Unresolved || row.status === ResolutionStatus.Pending;
  return open && row.encampFacilityId != null;
}
